module.exports = __webpack_public_path__ + "img/hero-background-desktop.fe70a146.jpg";